export const CHANGE_VALUE_TRANSITION_TIME = 700;
